import { pluginFactory } from '@/plugins/plugin'
import AutoRefresh, { TYPE } from './AutoRefresh.vue'
import services from '@/services'
import i18n from './i18n'

services.translation.init(i18n, { overwrite: false })

const AutoRefreshPlugin = pluginFactory({
  components: { AutoRefresh }
})

export { AutoRefreshPlugin, AutoRefresh, TYPE }
export default AutoRefresh
